import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import FilterRules from "./_components/filter-rules/FilterRules";
import TableRules from "./_table-rules/TableRules";

const RulesPage = () => {

    const { t } = useTranslation('booking');

    return (
        <>
            <SectionHeader title={t('label.rules')} />
            <Stack rowGap={3} p={3}>
                <FilterRules />
                <TableRules />
            </Stack>
        </>
    )
};

export default RulesPage;